import { MutationFunction, useMutation, useQueryClient } from '@tanstack/react-query'
import { authClient } from '@/utils/api'
import { AuthResponse, LoginCallbackInput, OidcClientConfig } from '../types/authTypes'
import { getConfigOptions } from './getConfig'
import { MutationConfig } from '@/utils/reactQuery'

type LoginCallbackMutationFunctionProps = {
  code: string
}

type LoginCallbackProps = LoginCallbackMutationFunctionProps & {
  config: OidcClientConfig
}

const loginCallback = async ({ config, code }: LoginCallbackProps): Promise<AuthResponse> => {
  const body: LoginCallbackInput = {
    grant_type: 'authorization_code',
    code: code,
    client_id: import.meta.env.VITE_AUTH_CLIENT_ID,
    redirect_uri: import.meta.env.VITE_AUTH_LOGIN_REDIRECT_URI,
  }
  const { data } = await authClient.post<AuthResponse>(new URL(config.token_endpoint).toString(), new URLSearchParams(body))
  return data
}

type UseLoginCallbackProps = {
  mutationConfig?: MutationConfig<MutationFunction<AuthResponse, LoginCallbackMutationFunctionProps>>
}

const useLoginCallback = ({ mutationConfig }: UseLoginCallbackProps = {}) => {
  const { ...restConfig } = mutationConfig || {}
  const queryClient = useQueryClient()

  return useMutation({
    ...restConfig,
    mutationFn: async ({ code }: LoginCallbackMutationFunctionProps) => {
      const configQuery = getConfigOptions()
      const config = queryClient.getQueryData(configQuery.queryKey) ?? (await queryClient.fetchQuery(configQuery))
      return loginCallback({ code, config })
    },
  })
}

export { loginCallback, useLoginCallback }
